<template>
  <v-row v-scroll="onScroll">
    <!-- header -->
    <mini-header :dense="true" title="Resumen del Documento" :breadcrumbs="breadcrumbs" :breadcrumbsItemDinamic="{ loading: $store.state.purchases.retrieveLoader, text: `${(activeDocument || {}).name } Nº ${instance.number}`}" :hiddenTab="true" :addPadding="true" :scroll="scroll">
      <template v-slot:main>
        <v-btn class="mr-2" @click="retrieve" outlined>
          <v-img contain :src="require(`@/assets/icon-update${$vuetify.theme.dark ? '-dark' : ''}.svg`)" />
        </v-btn>
        <v-btn class="mr-2" @click="modalEmail=true" :disabled="!instance?.email_id" outlined><v-icon left>mdi-eye</v-icon>Ver email</v-btn>
        <v-btn @click="downloadFile2('purchases', `${instance.type}_N${instance.number}`, 'rec-docs', 'xml', instance.id)" :disabled="$store.state.purchases.retrieveLoader" outlined><v-icon left>mdi-download</v-icon>Descargar documento</v-btn>
        <template v-if="instance?.status === 'APR'">
          <v-btn class="ml-2" @click="handleAcceptClick" outlined :ripple="false" :disabled="isAcceptDisabled">
            <v-icon left>mdi-file-document-check</v-icon>
            Aceptar
          </v-btn>
          <v-btn class="ml-2" @click="handleRejectClick" color="grey-900" :ripple="false" :disabled="isRejectDisabled">
            <v-icon left>mdi-file-document-remove</v-icon>
            Rechazar
          </v-btn>
        </template>
      </template>
    </mini-header>
    <!-- end header -->
    <v-col class="px-0" style="z-index: 0;">
      <skeleton-detail v-if="$store.state.purchases.retrieveLoader" />
      <div class="d-flex" v-else>
        <!-- detail card -->
        <div class="mr-6 mt-n1" style="min-width: 400px;">
          <div style="position:fixed!important;">
            <v-img contain :width="400" :height="110" :src="require(`@/assets/backgrounds/background-document-detail.svg`)">
              <span class="px-4 pt-4 subtitle-2 white--text font-weight-bold d-inline-block text-truncate" style="max-width: 400px;">
                {{instance.type | nameDocumentsType}}
              </span>
              <v-row class="ml-2 mt-3" align="end" no-gutters>
                <v-col cols="4" class="py-0 px-2">
                  <span class="d-block body-1 white--text">Total</span>
                  <span class="subtitle-2 white--text">
                    <span class="font-weight-bold">{{instance.amount_total }}
                      <span class="caption">{{instance.currency}}</span>
                    </span>
                  </span>
                </v-col>
                <v-col cols="5" class="py-0 px-2">
                  <span class="d-block body-1 white--text">Fecha</span>
                  <span class="subtitle-2 white--text">
                    <span class="font-weight-bold">{{instance.date | date}}</span>
                  </span>
                </v-col>
              </v-row>
            </v-img>
            <!-- assignment info -->
            <v-card class="mt-4 py-3" v-if="(instance.assignee_tax_id || instance.assignment_agency_status) && $store?.state?.auth?.account?.country === 'CL'" color="green-50" outlined style="border-color: var(--grey-900);">
              <v-row class="px-5" align="center" no-gutters>
                <v-icon size="18" color="grey-900" class="mr-2">mdi-file-arrow-left-right</v-icon>
                <span class="subtitle-2 grey-900--text font-weight-bold">Información de cesión</span>
              </v-row>
              <v-row class="px-5 mt-2" no-gutters>
                <v-col class="pa-0">
                  <span class="d-block body-1 grey-900--text">{{instance.assignee_name || 'Sin definir'}}</span>
                  <span class="subtitle-2 grey-900--text font-weight-bold">{{formatRut(instance.assignee_tax_id) || 'Sin definir'}}</span>
                </v-col>
                <v-col class="pa-0 text-right">
                  <span class="d-block body-1 grey-900--text">Fecha de cesión</span>
                  <span class="subtitle-2 grey-900--text font-weight-bold">{{instance.assignment_date | dateTimeSecond}}</span>
                </v-col>
              </v-row>
            </v-card>
            <!-- end assignment info -->
            <v-card class="pa-0 mt-4" width="400" transition="slide-y-transition" :min-height="instance.assignee_tax_id ? 'calc(100% - 585px)' : 'calc(100% - 278px)'" flat style="position:fixed!important;">
              <v-toolbar color="transparent" flat height="46">
                <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-bold">Resumen del documento</v-toolbar-title>
              </v-toolbar>
              <v-divider />
              <div class="py-4 px-5">
                <v-list class="v-list-form-main transparent pa-0">
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2">Razón Social</v-list-item-title>
                      <v-list-item-subtitle class="body-1">{{(instance || {}).supplier_name}}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="pa-0">
                      <v-list-item-title class="grey-500--text subtitle-2">{{$t('generals.RUT')}}</v-list-item-title>
                      <v-list-item-subtitle class="body-1">{{ formatRutChile((instance || {}).tax_id) }}</v-list-item-subtitle>
                    </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2">Tipo de documento</v-list-item-title>
                    <v-list-item-subtitle class="body-1">{{instance.type | nameDocumentsType}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0" v-if="instance.status !== 'draft'">
                    <v-list-item-title class="grey-500--text subtitle-2">{{ $t('generals.Folio #') }}</v-list-item-title>
                    <v-list-item-subtitle class="body-1">{{instance.number}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2">ID</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-tooltip color="grey-background" right transition="scale-transition" max-width="320">
                        <template v-slot:activator="{on}">
                          <v-btn class="grey-300--text" @click="toClipboard(instance.id)" text v-on="on" :ripple="false" style="justify-content: left;">{{instance.id}}</v-btn>
                        </template>
                        <span class="d-block px-3 py-2">Copiar</span>
                      </v-tooltip>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-title class="grey-500--text subtitle-2">Creado el</v-list-item-title>
                    <v-list-item-subtitle class="body-1">{{instance.created | dateTimeSecond}}</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </div>
            </v-card>
          </div>
        </div>
        <!-- end summary -->

        <!-- panels -->
        <div class="pb-5" style="flex:1; min-width: 180px;">
          <!-- compliance -->
          <v-card flat class="mb-5">
            <v-toolbar color="transparent" flat height="46">
              <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-bold">
                <v-row no-gutters align="center" justify="space-between">
                  <v-col class="pa-0">
                    <span class="ml-n1 subtitle-2 grey-700--text font-weight-semibold"><v-icon class="mr-2 mt-n1" small color="grey-700">mdi-shield-check</v-icon>Cumplimiento
                    </span>
                  </v-col>
                </v-row>
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text class="px-0 py-4">
              <v-skeleton-loader v-if="loadingSwap" class="rounded-md" type="list-item-three-line" />
              <v-list class="v-list-form-2-actions transparent pa-0" width="100%" v-else>
                <v-list-item class="px-5">
                  <v-list-item-title class="grey-500--text subtitle-2">Estado comercial</v-list-item-title>
                  <v-list-item-subtitle>
                    <chip-status :status="instance?.rec_status || 'PEN'" :detail="instance?.rec_status_info ? instance?.rec_status_info : null" :showDetail="true" type="purchases" :isTooltip="true" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-divider class="my-5" />
                <v-list-item class="px-5">
                  <v-list-item-title class="grey-500--text subtitle-2">Estado {{ $t('generals.SII') }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <chip-status :status="instance?.status" :showDetail="true" type="documents" :isTooltip="false" />
                  </v-list-item-subtitle>
                  <v-list-item-action class="ma-0" style="overflow: hidden">
                    <v-btn class="btnText" v-if="['FAI', 'SNT', 'CRE', 'ART', 'MRT'].includes(instance?.status)" @click="reprocessDoc" :disabled="disabledUpdate" text color="grey-900" :ripple="false">
                      <v-icon left color="grey-900">mdi-refresh</v-icon>
                      Actualizar estado
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item class="px-5" v-if="!['FAI', 'SNT', 'CRE', 'ART', 'MRT'].includes(instance?.status)">
                  <v-list-item-title class="grey-500--text subtitle-2">Fecha de validación</v-list-item-title>
                  <v-list-item-subtitle>
                    {{instance.validation_date | dateTimeSecond}}
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
          <!-- end compliance -->

          <!-- totals -->
          <v-expansion-panels v-model="panelTotals">
            <v-expansion-panel>
              <v-expansion-panel-header class="px-5 py-4">
                <v-row no-gutters align="center" justify="space-between">
                  <v-col class="pa-0">
                    <span class="ml-n1 subtitle-2 grey-700--text font-weight-semibold"><v-icon class="mr-2 mt-n1" small color="grey-700">mdi-currency-usd</v-icon>Detalle</span>
                  </v-col>
                  <v-col class="text-right mr-2 pa-0" v-if="panelTotals !== 0">
                    <span class="d-block grey-700--text body-1 font-weight-medium">{{instance.amount_total}} {{instance.currency}}</span>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="px-0 pb-4">
                <v-list class="transparent pa-0">
                  <v-list-item class="px-5">
                    <v-list-item-title class="subtitle-2">Subtotal</v-list-item-title>
                    <v-list-item-subtitle class="text-right font-weight-bold">{{instance.amount_subtotal}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-5">
                    <v-list-item-title class="subtitle-2">Descuento</v-list-item-title>
                    <v-list-item-subtitle class="text-right grey-500--text font-weight-bold">
                      <template v-if="instance.amount_discount">
                        {{instance.amount_discount}}
                        <template v-if="instance.discount_scheme === '%'">{{instance.discount_scheme}}</template>
                        <template v-if="instance.discount_scheme === '$'">{{instance.currency}}</template>
                      </template>
                      <template v-else>-</template>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <template v-if="(activeDocument || {}).has_taxes_detail">
                    <v-divider class="my-1" />
                    <v-list-item class="px-5">
                      <v-list-item-title class="subtitle-2">Exento</v-list-item-title>
                      <v-list-item-subtitle class="text-right grey-500--text font-weight-bold" v-if="instance.amount_exempt">{{instance.amount_exempt}}</v-list-item-subtitle>
                      <template v-else>-</template>
                    </v-list-item>
                    <template v-if="activeDocument.has_taxes">
                      <v-list-item class="px-5">
                        <v-list-item-title class="subtitle-2">Neto</v-list-item-title>
                        <v-list-item-subtitle class="text-right grey-500--text font-weight-bold">{{instance.amount_net}}</v-list-item-subtitle>
                      </v-list-item>
                      <v-divider class="my-1" />
                      <v-list-item class="px-5">
                        <v-list-item-title class="subtitle-2">Impuestos ({{activeDocument.tax_percent}}%)</v-list-item-title>
                        <v-list-item-subtitle class="text-right grey-500--text font-weight-bold">{{instance.amount_tax}}</v-list-item-subtitle>
                      </v-list-item>
                    </template>
                  </template>
                  <v-divider class="my-1" />
                  <v-list-item class="px-5">
                    <v-list-item-title class="body-1 grey-500--text font-weight-bold">Total documento</v-list-item-title>
                    <v-list-item-subtitle class="text-right body-1 grey-500--text font-weight-bold">{{instance.amount_total}} {{instance.currency}}</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- end totals -->

          <!-- pdf -->
          <v-expansion-panels class="mt-5" v-model="panelPDF">
            <v-expansion-panel>
              <v-expansion-panel-header class="px-5 py-4">
                <v-row no-gutters align="center">
                  <v-col class="pa-0">
                    <span class="subtitle-2 grey-700--text font-weight-semibold"><v-icon class="mr-2" small color="grey-700">mdi-text-box</v-icon>Visualizar PDF</span>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="px-0" style="min-height: 300px;">
                <render-pdf :basicRender="true" :documentType="((instance || {}).type || '') | nameDocumentsType" :number="instance.number" @close="modalPDF=false" :loaderRender="loaderRender" :renderUrl="renderUrl" :flat="true" :showToolbar="false" :showFormat="true"  />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- end pdf -->

          <!-- related documents -->
          <v-expansion-panels class="mt-5" v-model="panelRelatedDocuments">
            <v-expansion-panel>
              <v-expansion-panel-header class="px-4 py-3">
                <v-row no-gutters align="center" justify="space-between">
                  <span class="subtitle-2 grey-700--text font-weight-bold d-flex align-center"><v-icon size="18" left color="grey-700">mdi-file-document-multiple</v-icon>Referencias</span>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="px-0">
                <v-empty-state class="mt-n2 pb-2" v-if="!references?.length" type="documents" id="documentos" customClass="mt-1" :isFree="true" title="No hay información de referencias" :height="199" />
                <v-simple-table class="px-0 no-hover table-not-rounded" dense v-else>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left grey-700--text font-weight-medium" style="min-width: 180px;">Tipo de documento</th>
                        <th class="text-right grey-700--text font-weight-medium" style="min-width: 120px;">{{$t('generals.Folio')}}</th>
                        <th class="text-right grey-700--text font-weight-medium" style="min-width: 70px;">Fecha del doc.</th>
                      </tr>
                      <v-divider style="position: absolute;  margin-top: -10px; min-width: 100%; margin-left: -1px" />
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in references"
                        :key="item.number"
                        :style="isReferenceClickable(item) ? 'cursor: pointer' : ''"
                        @click="isReferenceClickable(item) && $router.push({ name: 'PurchaseList', params: $route.params, query: { type: item.type, series: item.series, serial: item.serial, _name: instance.number } })"
                      >
                        <td class="body-2">
                          <span class="d-inline-block text-truncate" style="max-width: 99%;" v-if="item.type">
                            {{item.type | nameReferencesType}}
                          </span>
                          <span class="body-2 text--disabled font-italic" v-else>Sin especificar</span>
                        </td>
                        <td class="text-right body-2">
                          <span>{{item.number}}</span>
                        </td>
                        <td class="text-right body-2">
                          <span v-if="item.date">{{item.date | date}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- end related documents -->

          <!-- events -->
          <v-card flat class="mt-5">
            <v-toolbar color="transparent" flat height="46">
              <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold"><v-icon size="18" left color="grey-700">mdi-timeline-clock</v-icon>Eventos</v-toolbar-title>
            </v-toolbar>
            <v-skeleton-loader v-if="eventLoading" class="mb-2 panel px-1 rounded-md" transition="fade-transition" type="list" />
            <template v-else-if="(eventsList || []).length ">
              <v-divider />
              <v-card-text class="pa-0">
                <v-list class="transparent px-0 py-2 dense">
                  <div v-for="(d, i) in events" :key="i">
                    <v-list-item class="px-5 py-0" :key="i">
                      <v-list-item-icon>
                        <v-icon color="grey-900">{{currentEvent(d.rec_event_type).icon}}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title class="ml-n5">
                        <span class="d-flex grey-700--text body-1">
                          <span class="font-weight-medium">{{currentEvent(d.rec_event_type).summary}}</span>
                          <template v-if="d.description">
                            <v-divider class="mx-2 my-1" vertical />
                            <span class="text-body-2 grey-700--text" v-if="d.description.length < 30" style="margin-top:2px">{{ d.description}}</span>
                            <v-tooltip v-else color="grey-background" right transition="scale-transition" width="500">
                              <template v-slot:activator="{on}">
                                <v-sheet class="grey-700--text" v-on="on" width="100%" height="20">
                                  <span class="d-inline-block text-truncate text-body-2" style="max-width: 90%;margin-top:2px">
                                    {{ d.description }}
                                  </span>
                                </v-sheet>
                              </template>
                              <span class="d-block px-3 py-2">{{d.description}}</span>
                            </v-tooltip>
                          </template>
                        </span>
                        <span class="d-block body-2 grey-300--text">{{d.created | dateTimeSecond}}</span>
                       </v-list-item-title>
                    </v-list-item>
                    <v-sheet class="text-left ml-8 mt-n4 mb-n2" v-if="i !== eventsList.length - 1" height="18">
                      <v-icon size="3" color="placeholder" style="position: absolute; left: 30px">mdi-circle</v-icon>
                      <v-divider vertical class="my-0" />
                      <v-icon class="mb-n1" size="3" color="placeholder" style="left: -1px; top: 7px">mdi-circle</v-icon>
                    </v-sheet>
                    </div>
                  <template v-if="eventsList.length > 3">
                    <v-divider class="mt-4" />
                    <v-btn class="mt-1 mb-n1 mx-5" color="grey-900" @click="showMoreEvents=!showMoreEvents" text>
                      {{ !showMoreEvents ? 'Ver todos los eventos' : 'Ver menos eventos' }} </v-btn>
                  </template>
                </v-list>
              </v-card-text>
            </template>
          </v-card>
          <!-- end events -->
        </div>
        <!-- end panels -->
      </div>
    </v-col>

    <!-- dialog accept/claim document (CL) -->
    <v-dialog v-model="dialogCL" width="600" persistent no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="46" class="transparent">
            <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">{{ dialogCLType === 'accept' ? 'Aceptar' : 'Rechazar' }} documento</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="closeCLDialog" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-5 py-2">
          <v-row class="pt-2" align="center">
            <v-col cols="4">
              <img :src="require(`@/assets/backgrounds/${dialogCLType === 'accept' ? 'modal-cl-accept' : 'modal-cl-claim'}.svg`)" :width="148" />
            </v-col>
            <v-col class="pr-4 pl-4">
              <v-list class="v-list-form pa-0 transparent">
                <v-list-item class="pa-0 mb-3">
                  <v-list-item-content>
                    <v-alert class="inf-alert-blue green-500--text rounded-md mb-3" :height="dialogCLType === 'accept' ? 88 : 58" dense text>
                      <div class="d-flex pa-0">
                        <v-icon color="green-500" size="22">mdi-information-outline</v-icon>
                        <div class="ml-4 text-description">
                          <span class="body-2" v-if="dialogCLType === 'accept'">
                            Al aceptar un documento en el SII, entrega acuse de recibo de mercaderías y/o servicios, y pasa a formar parte de propuesta de pago de IVA.
                          </span>
                          <span class="body-2" v-else>
                            Al rechazar un documento en el SII, quedará fuera de la propuesta de pago de IVA.
                          </span>
                        </div>
                      </div>
                    </v-alert>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
          <!-- Contenido para Aceptar -->
          <template v-if="dialogCLType === 'accept'">
            <span class="mt-n4 d-block grey-500--text font-weight-semibold body-1">Acuse de recibo del documento</span>
            <v-list-item class="pa-0 mt-n1">
              <v-list-item-content>
                <v-text-field
                  v-model="acceptRecinto"
                  outlined
                  dense
                  hide-details
                  placeholder="Recinto"
                  required
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </template>

          <!-- Contenido para Reclamar -->
          <template v-else>
            <span class="mt-n4 d-block grey-500--text font-weight-semibold body-1">Selecciona la respuesta al documento</span>
            <v-list-item class="pa-0">
              <v-list-item-content>
                <v-select
                  v-model="claimType"
                  :items="claimTypes"
                  item-text="label"
                  item-value="value"
                  outlined
                  dense
                  hide-details
                  placeholder="Seleccione motivo"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="pa-0">
              <v-list-item-content class="pt-0 mt-0">
                <v-text-field
                  v-model="claimReason"
                  outlined
                  dense
                  hide-details
                  placeholder="Motivo de rechazo"
                  required
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-2 px-5">
          <v-spacer/>
          <v-btn outlined @click="closeCLDialog" :ripple="false">Cancelar</v-btn>
          <v-btn
            color="grey-900"
            :disabled="dialogCLType === 'accept' ? !acceptRecinto : (!claimType || !claimReason)"
            @click="dialogCLType === 'accept' ? acceptDocumentCL() : claimDocumentCL()"
            :loading="loadingSwap"
            :ripple="false"
          >
            {{ dialogCLType === 'accept' ? 'Aceptar' : 'Rechazar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog accept/claim document (CL) -->

    <!-- dialog send email new ui -->
    <v-dialog v-model="modalEmail" width="700" persistent no-click-animation overlay-color="grey-500" scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar class="transparent" flat height="46">
            <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Email</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-3">
                <v-btn @click="modalEmail=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <v-col class="pa-0">
            <v-skeleton-loader v-if="loadingEmail" class="rounded-md mx-5" type="list-item-three-line, image" />
            <template v-else>
              <v-empty-state class="mt-8 mb-3" v-if="!!instance?.email_id && errorEmail" type="email" id="email" customClass="mt-5" :isFree="true" title="Email no disponible" :height="160" />
              <v-card class="transparent rounded-0 pa-0" v-else flat>
                <v-card-subtitle class="background pt-5 pb-3 px-5">
                  <div class="d-flex align-center">
                    <span class="grey-500--text body-1" style="min-width: 120px;">De</span>
                    <v-text-field v-model="messages.recipient" outlined required single-line dense readonly persistent-hint hide-details />
                  </div>
                  <div class="d-flex align-center mt-3">
                    <span class="grey-500--text body-1" style="min-width: 120px;">Asunto</span>
                    <v-text-field v-model="messages.subject"  outlined required single-line dense readonly maxlength="60" persistent-hint hide-details />
                  </div>
                  <div class="d-flex align-center mt-4" v-if="messages.date">
                    <span class="grey-500--text body-1" style="min-width: 120px;">Fecha de envío</span>
                    <span class="grey-300--text body-1" style="min-width: 120px;">{{ messages.date | dateTimeSecond }}</span>
                  </div>
                  <v-col cols="12" class="pa-0 mt-5">
                    <span class="grey-500--text body-1 mr-5 mb-3 d-block">Archivos adjuntos</span>
                    <v-row class="px-1">
                      <v-col cols="6" class="px-2 py-1" v-for="file in messages.files" :key="file.index">
                        <v-card class="px-2 py-0 my-1" @click="downloadFileEmail(file)" flat rounded="sm" :height="44" outlined>
                          <v-list-item class="ma-0 pa-0 d-flex align-center">
                            <v-list-item-icon class="mb-0 mt-2 ml-0 mr-2">
                              <v-icon color="grey-700" size="28">mdi-paperclip</v-icon>
                            </v-list-item-icon>
                            <v-list-item-subtitle>
                              <span class="caption grey-500--text d-inline-block text-truncate" :class="!file.size ? 'mt-2' : 'mt-1'" style="max-width: 98%;">{{ file.file_name }}</span>
                              <span class="mt-n4 d-block grey-300--text overline d-block" v-if="file.size">{{file.size }}</span>
                            </v-list-item-subtitle>
                          </v-list-item>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-btn class="mt-3" @click="downloadAllEmails" text color="grey-900"><v-icon left>mdi-download</v-icon>Descargar todos</v-btn>
                </v-card-subtitle>
                <v-divider />
                <v-col class="px-0 pt-5 ml-n1 pb-0">
                  <v-textarea class="elevation-0" v-model="messages.text" readonly auto-grow solo flat hide-details />
                </v-col>
              </v-card>
            </template>
          </v-col>
          <v-col>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog -->

    <!-- dialog grant -->
    <v-dialog v-model="dialogGrant" width="600" persistent no-click-animation scrollable overlay-color="grey-500">
      <v-card class="pa-0">
        <v-toolbar flat height="46" class="transparent">
          <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Ceder documento</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-3">
              <v-btn @click="dialogGrant=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-4">
          <v-row no-gutters>
            <v-col class="pa-0">
              <v-list class="v-list-form-extended transparent pa-0">
                <v-list-item class="px-5 pt-0">
                  <v-list-item-title>
                    <span class="font-weight-bold">Cedida a</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="px-5">
                  <v-list-item-title>{{$t('generals.RUT')}}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="6">
                      <v-text-field v-model="$v.grant.assigneeTaxId.$model" :error="$v.grant.assigneeTaxId.$error" v-dni="'CL'" outlined hide-details required single-line dense maxlength="32" />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-2 px-5">
                  <v-list-item-title>Nombre</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assigneeName.$model" :error="$v.grant.assigneeName.$error" outlined hide-details required single-line dense maxlength="100" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="px-5">
                  <v-list-item-title>Email</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assigneeEmail.$model" :error="$v.grant.assigneeEmail.$error" outlined hide-details required single-line dense maxlength="70" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-2 px-5">
                  <v-list-item-title>Dirección</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assigneeAddress.$model" :error="$v.grant.assigneeAddress.$error" outlined hide-details required single-line dense maxlength="70" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-divider class="my-3" />
                <v-list-item class="px-5">
                  <v-list-item-title>
                    <span class="font-weight-bold">Cedida por</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="pt-2 pb-1 px-5">
                  <v-list-item-title>Email</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assignorEmail.$model" :error="$v.grant.assignorEmail.$error" outlined hide-details required single-line dense maxlength="70" />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-2 px-5">
                  <v-list-item-title>Nombre</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-text-field v-model="$v.grant.assignorName.$model" :error="$v.grant.assignorName.$error" outlined hide-details required single-line dense maxlength="100" readonly />
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="px-5">
                  <v-list-item-title>{{$t('generals.RUT')}}</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="6">
                      <v-text-field v-model="$v.grant.assignorTaxId.$model" :error="$v.grant.assignorTaxId.$error" v-dni="'CL'" outlined hide-details required single-line dense maxlength="70" readonly />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-5 py-2">
          <v-spacer />
          <v-btn @click="dialogGrant=false" outlined>Cancelar</v-btn>
          <v-btn @click="createGrant" color="grey-900">Ceder documento</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog grant -->

    <!-- dialog loading assign -->
    <v-dialog v-model="dialogLoadingAssign" width="590" persistent scrollable no-click-animation overlay-color="grey-500">
      <v-card>
        <v-card-text class="px-6 py-6">
          <v-row class="pt-2 pb-4" align="center">
            <v-col cols="2" class="pr-0">
              <v-progress-circular indeterminate color="grey-900" :width="8" size="48" />
            </v-col>
            <v-col class="pl-0">
              <span class="d-block body-1 font-weight-bold pt-2 text-grey-700--text">Procesando tu solicitud...</span>
              <span class="d-block body-2 mt-1 text-grey-500--text">La cesión del documento se está ejecutando</span>
            </v-col>
          </v-row>
          <v-alert class="inf-alert-blue green-500--text rounded-md mt-2" :height="62" dense text>
            <div class="d-flex pa-0 my-1">
              <v-icon color="grey-900" size="22">mdi-information-outline</v-icon>
              <div class="ml-4">
                <span class="body-2" style="line-height: 14px;">Esta proceso
                  <span class="font-weight-bold">podría tardar varios minutos</span> en completarse.
                  <span class="font-weight-bold">El estado se actualizará automáticamente </span> en el documento.
                </span>
              </div>
            </div>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog loading assign -->

    <!-- dialog detail assign -->
    <v-dialog v-model="dialogDetailAssign" width="600" persistent no-click-animation scrollable overlay-color="grey-500">
      <v-card class="pa-0">
        <v-toolbar flat height="46" class="transparent">
          <v-toolbar-title class="px-5 subtitle-2 grey-500--text font-weight-semibold">Información de cesión</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-3">
              <v-btn @click="dialogDetailAssign=false" icon small retain-focus-on-click><v-icon color="grey-500" size="20">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-4">
          <div class="px-5 pb-2">
            <v-list class="v-list-form-main transparent pa-0">
              <v-list-item class="pa-0">
                <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="grey-500">mdi-clipboard</v-icon>Estado</v-list-item-title>
                <v-list-item-subtitle class="body-1">
                  <chip-status :status="instance.assignment_agency_status" :showDetail="true" :isTooltip="false" type="assign" />
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="pa-0">
                <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="grey-500">mdi-clipboard-search</v-icon>Detalle del estado</v-list-item-title>
                <v-list-item-subtitle class="body-1 align-self-start mt-2" style="white-space: normal !important">
                  <span v-if="instance?.assignment_agency_status_code">{{instance.assignment_agency_status_code}}</span>
                  <span v-else class="body-2 text--disabled font-italic d-block">Sin definir</span>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="pa-0">
                <v-list-item-title class="grey-500--text subtitle-2 font-weight-bold"><v-icon class="mr-3" size="20" left color="grey-500">mdi-clipboard-list</v-icon>Track ID</v-list-item-title>
                <v-list-item-subtitle class="body-1">
                  <v-tooltip v-if="instance?.assignment_agency_id" color="grey-background" right transition="scale-transition" max-width="300">
                    <template v-slot:activator="{on}">
                      <v-btn class="grey-300--text" @click="toClipboard(instance?.assignment_agency_id)" text v-on="on" :ripple="false" style="justify-content: left;">{{instance?.assignment_agency_id}}</v-btn>
                    </template>
                    <span class="d-block px-3 py-2">Copiar</span>
                  </v-tooltip>
                  <span v-else class="body-2 text--disabled font-italic d-block">Sin definir</span>
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </div>
          <v-divider />
          <v-col class="px-6 mb-4">
            <v-list-item-title class="mt-2">
              <v-icon size="18" left color="grey-500">mdi-file-arrow-left-right</v-icon>
              <span class="font-weight-bold grey-500--text">Cedida a</span>
            </v-list-item-title>
            <v-list class="v-list-form-main transparent pa-0">
              <v-list-item class="pa-0">
                <v-list-item-title class="grey-500--text subtitle-2">Nombre</v-list-item-title>
                <v-list-item-subtitle class="body-1">{{instance.assignee_name || 'Sin definir'}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="pa-0">
                <v-list-item-title class="grey-500--text subtitle-2">{{$t('generals.RUT')}}</v-list-item-title>
                <v-list-item-subtitle class="body-1">{{formatRut(instance.assignee_tax_id) || 'Sin definir'}}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="pa-0">
                <v-list-item-title class="grey-500--text subtitle-2">Fecha de cesión</v-list-item-title>
                <v-list-item-subtitle class="body-1">{{instance.assignment_date | dateTimeSecond}}</v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-col>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-5 py-2">
          <v-spacer />
          <v-btn @click="dialogDetailAssign=false" outlined>Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog detail assign -->
  </v-row>
</template>

<script>
  import { mapState } from 'vuex'
  import { saveAs } from 'file-saver'
  import VEmptyState from '@/components/commons/VEmptyState'
  import MiniHeader from '@/components/commons/MiniHeader'
  import ChipStatus from '@/components/commons/ChipStatus'
  import VModal from '@/components/commons/VPanel'
  import SkeletonDetail from '@/components/commons/skeletonLoader/SkeletonDetail'
  import RenderPdf from '@/components/files/RenderPdf'
  import DocumentsList from '@/modules/documents/components/DocumentsList'
  import GenericViewMixin from '@/mixins/GenericViewMixin'
  import RenderViewMixin from '@/mixins/RenderViewMixin'
  import TaxAgencyViewMixin from '@/mixins/TaxAgencyViewMixin'
  import DocumentTypes from '@/collections/documentTypes'
  import DocumentEvents from '@/collections/recsDocumentEvents'
  import PermissionDenied from '@/modules/http/views/PermissionDenied'
  import { email, maxLength, required } from 'vuelidate/lib/validators'
  import { rutValidator } from 'vue-dni'
  import { rutFormat } from 'rut-helpers'

  export default {
    mixins: [
      GenericViewMixin,
      RenderViewMixin,
      TaxAgencyViewMixin
    ],
   components: {
      VEmptyState,
      ChipStatus,
      MiniHeader,
      VModal,
      SkeletonDetail,
      RenderPdf,
      DocumentsList,
      PermissionDenied
    },
    data: () => ({
      showMoreEvents: false,
      eventLoading: false,
      loadingEmail: false,
      errorEmail: false,
      references: [],
      key: 0,
      modalEmail: false,
      emailsList: [],
      disabledUpdate: false,
      formatPDF: 1,
      scroll: 0,
      comments: '',
      dialogCL: false,
      dialogCLType: 'accept', // 'accept' o 'claim'
      loading: false,
      loadingSwap: false,
      // offsetTop: 0,
      panelIrsSii: [],
      panelComments: false,
      panelEmail: false,
      panelPDF: false,
      panelRelatedDocuments: false,
      panelTotals: 0,
      acceptRecinto: '',
      claimType: null,
      claimReason: '',
      claimTypes: [
        { value: 'RCD', label: 'Reclamo al contenido del documento' },
        { value: 'RFP', label: 'Reclamo por falta parcial de mercaderías' },
        { value: 'RFT', label: 'Reclamo por falta total de mercadería' }
      ],
      breadcrumbs: {
        main: 'Recepción',
        children: [
          {
            text: 'Documentos',
            route: 'PurchaseList'
          }
        ]
      },
      messages: {
        text: '',
        recipient: '',
        subject: '',
        type: ['pdf', 'xml'],
        files: [],
        date: null
      },
      grant: {
        assigneeTaxId: '',
        assigneeName: '',
        assigneeAddress: '',
        assigneeEmail: '',
        assignorEmail: '',
        assignorName: '',
        assignorTaxId: ''
      },
      dialogGrant: false,
      dialogDetailAssign: false,
      dialogLoadingAssign: false,
      loadingAssign: false
    }),
    computed: {
      ...mapState({
        instance: state => state.purchases.recdocsDetail,
        eventsList: state => state.purchases.eventsList
      }),
      activeDocument () {
        return DocumentTypes.find(d => d.id === this.instance.type)
      },
      canAcceptOrReject () {
        // Solo se pueden aceptar o reclamar: Facturas afectas (33), Facturas exentas (34) y Liquidación de factura (43)
        const allowedTypes = ['CL33', 'CL34', 'CL43']
        return this.instance?.type && allowedTypes.includes(String(this.instance.type))
      },
      isAcceptDisabled () {
        return this.instance.action_book !== null || !this.canAcceptOrReject
      },
      isRejectDisabled () {
        return this.instance.action_book !== null || !this.canAcceptOrReject
      },
      events () {
        return !this.showMoreEvents ? this.eventsList.slice(0, 3) : this.eventsList
      },
      currentEvent () {
        return (val) => {
          return DocumentEvents.find(({id}) => val === id) ?? {}
        }
      }
    },
    watch: {
      panelPDF (val) {
        this.modalRender = val
        if (val === 0) {
          this.$vuetify.goTo(0, { duration: '0', easing: 'linear' })
          if (!this.renderUrl) this.renderDocument2('documents', 'rec-docs', 'pdf', this.$route.params.id)
        }
        this.formatPDF = 1
      },
      formatPDF: {
        handler (val) {
          if (val === 1) this.renderDocument('documents')
          else {
            this.renderDocument('purchases', 'purchases', 'pdf', this.instance.id, { thermal_format: val})
          }
        },
        inmediate: true,
        deep: true
      },
      dialogGrant (val) {
        if (val) {
          this.$v.grant.$reset()
          this.grant.assignorName = this.$store.state.auth.account.name
          this.grant.assignorTaxId = this.$store.state.auth.account.tax_id
          this.grant.assignorEmail = this.$store?.state?.auth?.userAccount.email
        }
      },
      modalEmail (val) {
        if (val) this.getEmail()
        else {
        this.messages = {
          text: '',
          recipient: '',
          subject: '',
          type: ['pdf', 'xml'],
          files: [],
          date: null
          }
        }
      }
    },
  created () {
      this.retrieve()
    },
    methods: {
      isReferenceClickable (item = {}) {
        return ['CL61', 'CL56'].includes(item.type)
      },
      downloadFileEmail (file = {}) {
        this.$store.dispatch(`accounts/RETRIEVE`, {
          resource: `rec-emails/${this.instance.email_id}/attachments/${file.index}`,
          loader: false,
          responseType: 'arraybuffer'
        })
        .then((response) => {
          saveAs(new Blob([response.data], {type: `application/${file.mime_type}`}), file.file_name)
        })
      },
      downloadAllEmails () {
        this.$store.dispatch('accounts/RETRIEVE', {
          resource: `rec-emails/${this.instance.email_id}/attachments`,
          responseType: 'arraybuffer'
        })
        .then(async (response) => {
          const blob = await new Blob([response.data], {type: "application/zip"})
          saveAs(blob, response.headers['content-disposition'].match(/"([^"]*)"/g)[0].replace(/"/g, ''))
          this.$dialog.message.info('La descarga se ha realizado con éxito.')
        })
        .catch(() => {
          this.$dialog.message.error('Ha ocurrido un error en el proceso de descarga')
        })
      },
      remove (item) {
        const index = this.messages.recipient.indexOf(item)
        if (index >= 0) {
          this.messages.recipient.splice(index, 1)
        }
      },
      getEmail () {
        this.errorEmail = false
        this.loadingEmail = true
        this.$store.dispatch('documents/RETRIEVE', {
          resource: 'rec-emails',
          id: this.instance.email_id
        })
        .then((response) => {
          this.messages.recipient = response.data.from
          this.messages.subject = response.data.subject
          this.messages.files = response.data.attachments
          this.messages.text += response.data.body
          this.messages.date = response.data.sent_date
        })
        .catch(() => {
          this.errorEmail = true
        })
        .finally(() => {
          this.loadingEmail = false
        })
      },
      getEvents () {
        this.eventLoading = true
        this.$store.dispatch('purchases/LIST', {
          resource: `rec-docs/${this.instance.id}/events`
        })
        .finally(() => {
          this.eventLoading = false
        })
      },
      reprocessDoc () {
        this.loadingReprocessDoc = true
        this.$store.dispatch('purchases/GET', {
          resource: `rec-docs/${this.$route.params.id}/reprocess`
        })
        .then(() => {
          // this.$dialog.message.info('El documento fue reprocesado con éxito.')
          this.disabledUpdate = true
          // setTimeout(() => {
          //   this.retrieve()
          // }, 600)
        })
        .catch((error) => {
          this.$dialog.message.error(error.response.data.message)
        })
        .finally(() => {
          this.loadingReprocessDoc = false
          this.dialogReprocessDoc = false
        })
      },
      onScroll (e) {
        this.offsetTop = e.target?.scrollingElement?.scrollTop ?? 0
      },
      async handlePanel () {
        await this.$root.$emit('isClose', true)
        this.$router.replace({ name: 'DocumentsList', params: { ...this.$route.params } })
      },
      handleAcceptClick () {
        this.dialogCLType = 'accept'
        this.dialogCL = true
      },
      handleRejectClick () {
        this.dialogCLType = 'claim'
        this.dialogCL = true
      },
      closeCLDialog () {
        this.dialogCL = false
        this.acceptRecinto = ''
        this.claimType = null
        this.claimReason = ''
      },
      acceptDocumentCL () {
        if (!this.acceptRecinto) return

        this.loadingSwap = true
        this.$store.dispatch('documents/UPDATE', {
          resource: `rec-docs/${this.$route.params.id}/book`,
          payload: {
            action: 'ERM',
            message: this.acceptRecinto
          }
        })
        .then(() => {
          this.$dialog.message.info('El documento ha sido aceptado con éxito')
          this.retrieve()
          this.closeCLDialog()
        })
        .catch((error) => {
          this.$dialog.message.error(this.parseErrors(error.response.data))
        })
        .finally(() => {
          this.loadingSwap = false
        })
      },
      claimDocumentCL () {
        if (!this.claimType || !this.claimReason) return

        this.loadingSwap = true
        this.$store.dispatch('documents/UPDATE', {
          resource: `rec-docs/${this.$route.params.id}/book`,
          payload: {
            action: this.claimType,
            message: this.claimReason
          }
        })
        .then(() => {
          this.$dialog.message.info('El documento ha sido reclamado con éxito')
          this.retrieve()
          this.closeCLDialog()
        })
        .catch((error) => {
          this.$dialog.message.error(this.parseErrors(error.response.data))
        })
        .finally(() => {
          this.loadingSwap = false
        })
      },
      formatRut (rut) {
        if (!rut) return ''
        if (this.$store.state.auth.account.country === 'CL') {
          return rutFormat(rut)
        }
        return rut
      },
      createGrant () {
        this.$v.grant.$touch()
        if (this.$v.grant.$invalid) {
          return false
        }
        this.dialogGrant = false
        this.dialogLoadingAssign = true
        this.loadingAssign = true

        const payload = {
          ...this.grant,
          assigneeTaxId: this.grant.assigneeTaxId.replace(/\./g, ''),
          assignorTaxId: this.grant.assignorTaxId.replace(/\./g, '')
        }

        this.$store.dispatch('irs/UPDATE', {
          resource: `documents/${this.$route.params.id}/assign`,
          payload: payload
        })
        .then((response) => {
          this.grant = response.data
          this.dialogGrant = false
          this.$dialog.message.info('La cesión del documento se ha realizado con éxito')
        })
        .catch((error) => {
          this.$dialog.message.error(error.response.data.message)
        })
        .finally(() => {
          setTimeout(() => {
            this.retrieve()
            this.loadingAssign = false
            this.dialogLoadingAssign = false
          }, 4000)
        })
      },
      retrieve () {
        this.$store.dispatch('purchases/RETRIEVE', {
          resource: 'rec-docs',
          id: this.$route.params.id
        })
        .then((response) => {
          this.references = response.data.references
          this.getEvents()
        })
      }
    },
    validations: {
      grant: {
        assigneeTaxId: {
          required,
          maxLength: maxLength(32),
          rutValidator
        },
        assigneeName: {
          required,
          maxLength: maxLength(100)
        },
        assigneeAddress: {
          required,
          maxLength: maxLength(70)
        },
        assigneeEmail: {
          required,
          email,
          maxLength: maxLength(70)
        },
        assignorEmail: {
          required,
          email,
          maxLength: maxLength(70)
        },
        assignorName: {
          required,
          maxLength: maxLength(100)
        },
        assignorTaxId: {
          required,
          maxLength: maxLength(70),
          rutValidator
        }
      }
    }
  }
</script>
<style>
.v-list--three-line .v-list-item .v-list-item__subtitle, .v-list-item--three-line .v-list-item__subtitle {
  -webkit-line-clamp: 2 !important;
}
</style>